module.exports = "<footer class=\"footer text-center\"> 2019 &copy; Wreams - <a href=\"http://wreamapp.com/\" target=\"_blank\">www.wreamapp.com</a></footer>\n"